import {
    REQUEST_STATE,

    CORE_LOAD_SETTING_REQUEST,
    CORE_LOAD_SETTING_SUCCESS,
    CORE_LOAD_SETTING_FAILURE,
} from '../types'

const requestState = REQUEST_STATE

export default {
    setting: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_SETTING_REQUEST:
                return state
            case CORE_LOAD_SETTING_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_LOAD_SETTING_FAILURE:
                return {}
            default:
                return state
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/setting.js